<template>
  <v-container class="fill-height d-flex align-center justify-center" style="min-height: 80vh;">
    <v-card flat max-width="480" class="text-center pa-8 mx-auto">
      <v-icon size="80" color="warning" class="mb-4">mdi-shield-off-outline</v-icon>
      <h2 class="text-h5 font-weight-bold mb-4">{{ $t("message.not_active") }}</h2>
      <p class="body-2 grey--text mb-6">{{ $t("message.not_active_check_subscription_hint") }}</p>
      <v-btn color="primary" outlined @click="$router.push({ name: 'upgrade-plan-adminplus' })">
        {{ $t("message.manage_plan") }}
      </v-btn>
    </v-card>
  </v-container>
</template>
<script>
export default {};
</script>

<style scoped></style>
